import { mapStyleSchemaParser } from 'Map/configurer/styleOptionInitialization/tierStyleSchemaParser';
import { isString } from 'lodash';
import ThemeWrapper from 'Map/configurer/styleOptionInitialization/themeWrapper';
import sourceValidationConfigurer from 'Map/map/sourceValidation/sourceValidationConfigurer';

async function removeAllTiers(extendedMap) {
    const tiers = extendedMap._tiersContainer.getTiers();
    const tiersToRemove = [];
    tiers.forEach((tier) => {
        tiersToRemove.push(extendedMap.removeTier(tier.getId()));
    });
    return Promise.all(tiersToRemove);
}

function _recreateTiers(style) {
    this.options.style = style;
    if (isString(style)) {
        this.options.theme = mapStyleSchemaParser(this.options.style);
    } else {
        this.options.theme = new ThemeWrapper(ThemeWrapper.TYPE.OBJECT, {
            styleObject: this.options.style
        });
    }
    this._populateTiers();
}

export default {
    _removeAllTiers: removeAllTiers,
    _recreateTiers: _recreateTiers,
    setStyle: function(style) {
        sourceValidationConfigurer.tearDown(this);
        removeAllTiers(this).then(() => {
            _recreateTiers.call(this, style);
            sourceValidationConfigurer.setUp(this);
        });
    }
};



// WEBPACK FOOTER //
// ./map/map/mapboxOverriddenMethods/setStyleOverride.js